<template>
  <div>
    <deal-form
      v-if="modalVisible"
      :deal-id="dealId"
      :is-read-only="isReadOnly"
      :modal-visible="modalVisible"
      @close="closeModal"
      @close-and-refresh="closeAndRefresh"
      @save-event="saveEvent"
      @create-new="closeAndOpenModalCreate"
    />
    <div v-show="!modalVisible">
      <page-toolbar>
        <kendo-dropdownlist
          :data-source="testTypeDataSource"
          :data-text-field="'testTypeName'"
          :data-value-field="'testTypeId'"
          v-model="testTypeId"
          style="width: 130px;"
          @change="testTypeDropDownListChange"
        >
        </kendo-dropdownlist>
        <period-control @change="periodChange" v-show="testTypeId != 1"> </period-control>

        <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
      </page-toolbar>
      <kendo-grid
        height="calc(100vh - 145px)"
        ref="grid"
        :dataSource="topDataSource"
        :editable="false"
        :filterable="true"
        :sortable="true"
        :pageable-always-visible="true"
        :columns="topColumns"
        :detailInit="detailInit"
        :autoBind="false"
      >
      </kendo-grid>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {enableExportExcel, getExportExcelLink} from '@/helpers/export-helper'
import {getDataItem} from '@/helpers/kendo-helpers'
import PeriodControl from '@/components/PeriodControl'
import DealForm from '@/views/List/Deal/DealForm'
import PageToolbar from '@/components/PageToolbar'
import security from '@/mixins/security'

const $ = kendo.jQuery

export default {
  mixins: [security],
  mounted() {
    let grid = this.$refs.grid.kendoWidget()
    grid.element.on('click', '.dealCodeLink', e => {
      const dataItem = getDataItem(e.target)
      this.modalVisible = true
      this.dealId = dataItem.dealId
    })
  },
  data() {
    return {
      dealId: null,
      modalVisible: false,
      testTypeId: 2,
      evalDate: null,
      topColumns: [
        {
          field: 'operationCode',
          title: 'Number',
          width: 100,
          attributes: {style: 'text-align: center;'},
          template:
            '<a data-dealid="#=dealId#" href="javascript:;" class="dealCodeLink">#=operationCode#</a>',
        },
        {
          field: 'sectorName',
          title: 'Company',
          width: 150,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'designationDate',
          title: 'Desig. Date',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'designatedAmount',
          title: 'Desig. Notional',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'hedgedPeriod',
          title: 'Hedged CF Period',
          width: 100,
          attributes: {style: 'text-align: right;'},
        },
        {
          field: 'beta',
          title: 'Beta',
          width: 82,
          attributes: {style: 'text-align: right;'},
          format: '{0:P2}',
        },
        {
          field: 'rsq',
          title: 'RSQ',
          width: 82,
          attributes: {style: 'text-align: right;'},
          format: '{0:P2}',
        },
        {
          field: 'fdist',
          title: 'Sig of F',
          width: 82,
          attributes: {style: 'text-align: right;'},
          format: '{0:P2}',
        },
        {
          field: 'isEfficient',
          title: 'Effective',
          width: 100,
          attributes: {style: 'text-align: center;'},
        },
        {
          field: 'upToNowHedge',
          title: 'Previous Hedges',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'toHedge',
          title: 'Expected Cash Receipt',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'hypContractRate',
          title: 'Hypotetical Derivative Rate',
          width: 114,
          attributes: {style: 'text-align: right;'},
          format: '{0:N6}',
        },
        {
          field: 'hypStartDate',
          title: 'Start Date',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'hypEndDate',
          title: 'End Date',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'hypSettlementDate',
          title: 'Settlement',
          width: 114,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'oci',
          title: 'OCI Change',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'ineffectiveness',
          title: 'Cumulative Ineffectiveness',
          width: 130,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'gainLossHedging',
          title: 'Gain (Loss) Hedged Item',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'gainLossTrade',
          title: 'Gain (Loss) Hedge',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'terminationDate',
          title: 'Termination Date',
          width: 114,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'mtmOnDesignation',
          title: 'MTM On Designation',
          width: 114,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'fwdPoints',
          title: 'Intra Day Adjustment',
          width: 114,
          attributes: {style: 'text-align: right;'},
          format: '{0:N6}',
        },
      ],
      topDataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/fxDesignation',
            data: () => ({
              clientId: this.clientId,
              testTypeId: this.testTypeId,
              evalDate: this.evalDate,
            }),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'designEvalId',
            fields: {
              dealId: {type: 'number'},
              designEvalId: {type: 'number'},
              operationCode: {type: 'string'},
              sectorName: {type: 'string'},
              designationDate: {type: 'date'},
              designatedAmount: {type: 'number'},
              hedgedPeriod: {type: 'string'},
              evalDate: {type: 'date'},
              beta: {type: 'number'},
              rsq: {type: 'number'},
              fdist: {type: 'number'},
              isEfficient: {type: 'boolean'},
              upToNowHedge: {type: 'number'},
              toHedge: {type: 'number'},
              hypContractRate: {type: 'number'},
              hypStartDate: {type: 'date'},
              hypEndDate: {type: 'date'},
              hypSettlementDate: {type: 'date'},
              oci: {type: 'number'},
              reclassOci: {type: 'number'},
              ineffectiveness: {type: 'number'},
              gainLossTrade: {type: 'number'},
              gainLossHedging: {type: 'number'},
              reclassDate: {type: 'date'},
              interest: {type: 'number'},
              terminationDate: {type: 'date'},
              maturityDate: {type: 'date'},
              fwdPoints: {type: 'number'},
            },
          },
        },
      }),
      testTypeDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/fxDesignation/getTestTypes',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
    }
  },
  methods: {
    closeAndRefresh() {
      this.topDataSource.read()
      this.closeModal()
    },
    closeModal() {
      this.dealId = null
      this.modalVisible = false
    },
    saveEvent(dealId) {
      this.dealId = dealId
      this.topDataSource.read()
    },
    closeAndOpenModalCreate() {
      this.closeModal()

      setTimeout(() => {
        this.openModalCreate()
      }, 500)
    },
    testTypeDropDownListChange(e) {
      this.testTypeId = +e.sender.value()
      this.topDataSource.read()
    },
    periodChange(e) {
      this.evalDate = e.endDate
      this.topDataSource.read()
    },
    exportToExcel() {
      const grid = this.$refs.grid.kendoWidget()
      const actionUrl = '/api/heroux/fxDesignation/exportToExcel'
      const newHref = getExportExcelLink(grid, actionUrl)

      window.location.href = newHref
    },
    detailInit(e) {
      const vm = this
      const $container = $("<div id='detailGrid'/>")
      const designEvalId = e.data.designEvalId
      const columns = [
        {
          field: 'drawNumber',
          title: 'Scenario',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N0}',
        },
        {
          field: 'drawDate1',
          title: 'Start Date',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'curveDate1',
          title: 'Curve Date Start',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'tFwdH1',
          title: 'Fwd HD Start',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N8}',
        },
        {
          field: 'dFwdH1',
          title: 'DF HD Start',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N8}',
        },
        {
          field: 'mvH1',
          title: 'FV HD Start',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N2}',
        },
        {
          field: 'tFwdHh1',
          title: 'Fwd HI Start',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N8}',
        },
        {
          field: 'dFwdHh1',
          title: 'DF HI Start',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N8}',
        },
        {
          field: 'mvHh1',
          title: 'FV HI Start',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N2}',
        },
        {
          field: 'drawDate2',
          title: 'End Date',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'curveDate2',
          title: 'Curve Date End',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'tFwdH2',
          title: 'Fwd HD End',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N8}',
        },
        {
          field: 'dFwdH2',
          title: 'DF HD End',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N8}',
        },
        {
          field: 'mvH2',
          title: 'FV HD End',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N2}',
        },
        {
          field: 'tFwdHh2',
          title: 'Fwd HI End',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N8}',
        },
        {
          field: 'DFwdHh2',
          title: 'DF HI End',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N8}',
        },
        {
          field: 'mvHh2',
          title: 'FV HI End',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N2}',
        },
        {
          field: 'diffMvh',
          title: 'FV Chg HD',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N2}',
        },
        {
          field: 'diffMvHh',
          title: 'FV Chg HI',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:N2}',
        },
      ]

      const detailGrid = $container
        .appendTo(e.detailCell)
        .kendoGrid({
          dataSource: {
            type: 'aspnetmvc-ajax',
            serverPaging: true,
            serverFiltering: true,
            serverSorting: true,
            pageSize: 30,
            transport: {
              read: {
                type: 'GET',
                url: '/api/heroux/fxDesignation/gridDetailSource',
                data: () => ({
                  designEvalId: designEvalId,
                  testTypeId: vm.testTypeId,
                }),
                dataType: 'json',
              },
            },
            schema: {
              errors: 'errors',
              total: 'total',
              data: 'data',
              model: {
                id: 'testEvalId',
                fields: {
                  testEvalId: {type: 'number'},
                  drawNumber: {type: 'number'},
                  drawDate1: {type: 'date'},
                  curveDate1: {type: 'date'},
                  tFwdH1: {type: 'number'},
                  dFwdH1: {type: 'number'},
                  mvH1: {type: 'number'},
                  tFwdHh1: {type: 'number'},
                  dFwdHh1: {type: 'number'},
                  mvHh1: {type: 'number'},
                  drawDate2: {type: 'date'},
                  curveDate2: {type: 'date'},
                  tFwdH2: {type: 'number'},
                  dFwdH2: {type: 'number'},
                  mvH2: {type: 'number'},
                  tFwdHh2: {type: 'number'},
                  dFwdHh2: {type: 'number'},
                  mvHh2: {type: 'number'},
                  diffMvh: {type: 'number'},
                  diffMvHh: {type: 'number'},
                  evalDate: {type: 'date'},
                  trId: {type: 'number'},
                  hypTrId: {type: 'number'},
                  openDate: {type: 'date'},
                  closeDate: {type: 'date'},
                  startAdjust: {type: 'number'},
                  endAdjust: {type: 'number'},
                  designationDate: {type: 'date'},
                  minDate: {type: 'date'},
                },
              },
            },
          },
          toolbar: [],
          editable: false,
          scrollable: false,
          sortable: false,
          pageable: false,
          columns: columns,
        })
        .data('kendoGrid')

      enableExportExcel(detailGrid, '/api/heroux/fxDesignation/exportDetail')
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
  },
  components: {
    PageToolbar,
    PeriodControl,
    DealForm,
  },
}
</script>
